import { render, staticRenderFns } from "./BaseModel.vue?vue&type=template&id=6e29a141&scoped=true&"
import script from "./BaseModel.vue?vue&type=script&lang=js&"
export * from "./BaseModel.vue?vue&type=script&lang=js&"
import style0 from "./BaseModel.vue?vue&type=style&index=0&id=6e29a141&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e29a141",
  null
  
)

export default component.exports